module.exports = __webpack_public_path__ + "img/scan.2bdbfe6a.png";